/**
 * Initialize imageGalleryCarousel
 *
 * @class imageGalleryCarousel
 */

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

class imageGalleryCarousel {

  constructor(elem, params = {}) {
    if (!elem) {
      return;
    }

    this.elem = elem;

    const defaultOptions = {
      effect: 'slide',
      simulateTouch: true,
      loop: false,
      speed: 500,
      spaceBetween: 15,
      centerInsufficientSlides: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      slidesPerGroupAuto: true, // not working..
      breakpoints: {
        992: {
          spaceBetween: 35,
          slidesPerGroup: 4
        },
        600: {
          slidesPerGroup: 2
        }
      }
    };

    const carouselOptions = defaultOptions;
    Object.keys(params).forEach((key, i) => {
      carouselOptions[key] = params[key];
    });

    // Arrow navigation
    if (params.navigation) {
      const prev = document.createElement('button');
      prev.classList.add('swiper-button-prev', 'm-image-carousel__navigation', 'm-image-carousel__navigation--prev');

      const next = document.createElement('button');
      next.classList.add('swiper-button-next', 'm-image-carousel__navigation', 'm-image-carousel__navigation--next');

      this.elem.parentNode.appendChild(prev);
      this.elem.parentNode.appendChild(next);

      // Add navigation
      carouselOptions.navigation = {
        nextEl: next,
        prevEl: prev,
      };
    }

    this.carousel = new Swiper(this.elem, carouselOptions);

    return this.carousel;
  }
}


export { imageGalleryCarousel };
